/**
 * Axios 超时（毫秒）。默认实例 15s 对大文件 multipart 过短，上传单独拉长。
 * @see frontend/src/api/http.js
 */

/** multipart / 大文件上传（FormData），含 OSS、大图压缩等耗时 */
export const MULTIPART_UPLOAD_TIMEOUT_MS = 300000

/** 报关单反馈 POST（JSON，附图 meta 或链路较慢） */
export const DECLARATION_FEEDBACK_POST_TIMEOUT_MS = 120000
